module.exports = __webpack_public_path__ + "img/logo-talabat.3d1c7b7d.png";